<template>
    <BaseLayout>  
        <!-- <div class="about"> -->
          <!-- <TitleModel
          :title="'服务介绍'"
          :content="'TAO家，西雅图No.1实力伴君品牌， 满足你想的…你要的…你的原始欲望。'" 
            />  
      
          <PContentModel>
              <P>公司成立于2013年，提供Incall/Outcall、美女出钟、包夜包养、伴游陪赌及私人定制服务。 现为美洲最大规模、最多极品、最高性价比的龙头企业。多年来秉承客户至上的理念诚信经营，承包无数美洲狼友们的性福。约妹少走弯路，认准 TT 品牌。</P>
              <P>本公司汇集全球各国MM于西雅图，主要来自中国、港澳台、日韩东南亚及欧美地区。为您提供在澳华人留学生、世界名校交换生、职场兼职办公室女郎、网红小艺人、高端外围模特、空姐少妇、专业技师等等，是真正的男性天堂，拥有您能想到的一切类型。</P>
              <P>我们信誉担保所有 MM 资料及性息全部属实。每位 MM 提供至少 5 张照片、详细的文字介绍、真实的客户反馈及验证。</P>
              <P>公司主营西雅图市中心及东南区Incall，即您来我们的酒店或公寓，也提供西雅图全城 Outcall，即外送上门。</P>
              <P>除西雅图外，我们承接全球范围出钟空降/伴游陪赌/女友租赁/团体及私人定制业务。 如您有较为小众的需求，也欢迎随时咨询，我们将竭尽所能为您安排。</P>
          </PContentModel> -->
 
          <TitleModel
            :title="'客户须知'"
            content="OD 家真诚的重视每一位客户的预约体验，您的肯定是我们前进的动力。为使您与我们的 MM 和谐愉快的度过每段约会时光，希望您在预约前浏览此声明。" 
            /> 

          <PContentModel>
            <P v-html="khHtmlStr"></P>
          </PContentModel>

          <TitleModel
            :title="'服务介绍'"
            content="Tao家，美洲No.1实力伴君品牌， 满足你想的…你要的…你的原始欲望。" 
            content2=" "
            content3=" "/> 

          <PContentModel>
            <P v-html="fwtmlStr"></P>
          </PContentModel>


          <TitleModel
            :title="'收费方式'"
            content=" " 
            content2=" "
            content3=" "/> 

          <PContentModel>
            <P v-html="sfHtmlStr"></P>
          </PContentModel>
             
        <!-- </div>  -->
    </BaseLayout>
</template>

<script>
import BaseLayout from '@/components/BaseLayout.vue';
import TitleModel from '@/components/TitleModel.vue';
import PContentModel from '@/components/PContentModel.vue';
export default {
  name: 'AboutPage',
  components: {
    BaseLayout,
    TitleModel,
    PContentModel
  },
  data() {
    return {
      showModal: false,
      khHtmlStr:" ",
      fwtmlStr:" ",
      sfHtmlStr:" "
    }
  },
  created() {
    let  _blocks = this.$store.state.baseInfo.block 
   let baseInfoJson = this.$local.getItem('baseInfoJson');  
   if(baseInfoJson){
    let baseInfo = JSON.parse(baseInfoJson);
    _blocks = baseInfo.block;
   }

   _blocks = _blocks.filter(item => item.status === "4");
   if(_blocks.length > 2){
    this.khHtmlStr = _blocks[0].content;
    this.fwtmlStr = _blocks[1].content;
    this.sfHtmlStr = _blocks[2].content;
   } 
  //  console.log('----block',_blocks);
  },
}
</script>

<style scoped>

</style>